module.exports = __webpack_public_path__ + "static/media/informeusodesuelo.1e534ab1.png";